import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-ink-50 px-6"
            data-testid="not-found-page"
        >
            <div className="max-w-md w-full bg-white border border-border rounded-sm p-10 text-center mx-auto">
                <Compass className="h-10 w-10 text-florefy-900 mx-auto mb-4" />
                <div className="font-mono text-[10px] uppercase tracking-widest text-ink-500 mb-2">
                    404 — pagina niet gevonden
                </div>
                <h1 className="text-2xl font-semibold text-ink-900 mb-2">
                    Daar staat niets
                </h1>
                <p className="text-ink-600 mb-6">
                    De pagina die je zocht bestaat niet (meer). Misschien is hij
                    verplaatst of heb je een verkeerde link gevolgd.
                </p>
                <Link
                    to="/dashboard"
                    className="inline-block px-4 py-2 bg-florefy-900 text-white font-mono text-sm uppercase tracking-widest hover:bg-florefy-700 transition-colors rounded-sm"
                    data-testid="not-found-home"
                >
                    Terug naar dashboard
                </Link>
            </div>
        </div>
    );
}
